import { Stack } from "@mui/material";
import { IngredientFormType } from "../../IngredientForm.types";
import { GenericAccordion } from "@foodpilot/foods";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import MediumForklift from "src/assets/icons/forklift-medium.svg?react";

import { Button, useFormBaseContext } from "@foodpilot/foods";
import { useTranslation } from "react-i18next";
import CreateOutlined from "@mui/icons-material/CreateOutlined";
import { InformationSummary } from "src/components/Summary/IngredientSummary/InformationSummary";
import { SupplierSummary } from "src/components/Summary/IngredientSummary/SupplierSummary";
import { useFoodpilotContext } from "src/context/FoodpilotContext";

type ModifyButtonProps = {
    pageNumber: number;
};
export const ModifyButton = (props: ModifyButtonProps) => {
    const { setPage } = useFormBaseContext();
    const { t } = useTranslation();

    const modifyText = t("modifier");
    return (
        <Button
            variant="white-filled"
            startIcon={<CreateOutlined />}
            sx={{ marginRight: "24px", borderRadius: "44px" }}
            onClick={() => setPage(props.pageNumber)}
        >
            {modifyText}
        </Button>
    );
};

type Page3Props = {
    ingredient: IngredientFormType;
};

const Page3 = (props: Page3Props) => {
    const { isUserOfTypeSupplier } = useFoodpilotContext();
    const { t } = useTranslation();
    const { ingredient } = props;

    const isSupplier = isUserOfTypeSupplier();

    return (
        <div>
            <Stack direction="column" useFlexGap gap="8px" paddingTop={3}>
                <GenericAccordion
                    headerIcon={<InfoOutlined />}
                    headerText={t("general_information")}
                    controls={<ModifyButton pageNumber={0} />}
                >
                    <InformationSummary ingredient={ingredient} />
                </GenericAccordion>

                {!isSupplier && (
                    <GenericAccordion
                        headerIcon={<MediumForklift />}
                        headerText={t("suppliers")}
                        controls={<ModifyButton pageNumber={1} />}
                    >
                        <SupplierSummary suppliers={ingredient.suppliers} />
                    </GenericAccordion>
                )}
            </Stack>
        </div>
    );
};
export default Page3;
